import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import VueTelInput from 'vue-tel-input';
import store from "./store";
import axios from "axios";

axios.defaults.baseURL = "https://projects.dotlinkertech.com/metzbackend/public/api/" 

createApp(App).use(store).use(VueTelInput).use(router).mount('#app')